import { useEffect, useState } from "react";
import { Phone, X } from "lucide-react";
import { trackConversion } from "@/lib/gtag";

const DELAY_MS = 20000;

/**
 * Mobile-only nudge: if the visitor hasn't engaged with the booking form
 * within 20 seconds, offer a one-tap call instead.
 */
export function IdleCallNudge() {
  const [show, setShow] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    let engaged = false;
    const onEngage = (e: Event) => {
      const el = e.target as HTMLElement | null;
      if (el?.closest("form, input, select, textarea")) {
        engaged = true;
        setShow(false);
      }
    };
    document.addEventListener("focusin", onEngage);
    document.addEventListener("input", onEngage);
    const t = window.setTimeout(() => {
      if (!engaged) setShow(true);
    }, DELAY_MS);
    return () => {
      window.clearTimeout(t);
      document.removeEventListener("focusin", onEngage);
      document.removeEventListener("input", onEngage);
    };
  }, []);

  if (!show || dismissed) return null;

  return (
    <div className="fixed inset-x-0 bottom-[72px] z-40 px-3 lg:hidden">
      <div className="mx-auto flex max-w-[600px] items-center gap-3 rounded-full border border-primary/60 bg-card/95 px-4 py-2.5 shadow-lg backdrop-blur">
        <a
          href="tel:0493100265"
          onClick={() => trackConversion("phoneCall")}
          className="flex min-w-0 flex-1 items-center gap-2 text-sm font-semibold text-foreground"
        >
          <Phone className="h-4 w-4 shrink-0 text-primary" />
          <span className="truncate">Prefer to talk? Tap to call — answered 24/7</span>
        </a>
        <button
          type="button"
          onClick={() => setDismissed(true)}
          aria-label="Dismiss call reminder"
          className="grid h-8 w-8 shrink-0 place-items-center rounded-full text-muted-foreground hover:text-foreground"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}